/**
 * Consultations run on Zoom (George, Oct 5, 2026): Concord creates each meeting through the
 * Zoom API and sends its link. A navigator can still paste a Zoom link by hand, to use a
 * meeting of their own. SecureVideo, the Phase 1 provider, is no longer accepted.
 */
export const JOIN_LINK_HOSTS = [{ name: 'Zoom', host: 'zoom.us' }] as const;

export type JoinUrlCheck = { ok: true; url: string } | { ok: false; message: string };

/** The service a join link opens, or null when it is on none of the accepted hosts. */
export function joinLinkService(url: string): (typeof JOIN_LINK_HOSTS)[number]['name'] | null {
  let host: string;
  try {
    host = new URL(url).hostname.toLowerCase();
  } catch {
    return null;
  }
  return JOIN_LINK_HOSTS.find((h) => host === h.host || host.endsWith(`.${h.host}`))?.name ?? null;
}

/** A pasted join link must be https on zoom.us or one of its subdomains. */
export function checkJoinUrl(input: string): JoinUrlCheck {
  let u: URL;
  try {
    u = new URL(input.trim());
  } catch {
    return { ok: false, message: 'Enter the full Zoom link, starting with https://' };
  }
  if (u.protocol !== 'https:') return { ok: false, message: 'The Zoom link must start with https://' };
  if (!joinLinkService(u.href)) return { ok: false, message: 'Use a Zoom meeting link (zoom.us).' };
  if (u.username || u.password) return { ok: false, message: 'Use the Zoom link as Zoom gives it.' };
  return { ok: true, url: u.href };
}
